import { Button } from "@/components/ui/button";
import { SrIcon } from "@/components/ui/SrIcon";
import { downloadCsv, extrasListToCsv, type ExtraListRow } from "@/lib/report-export";
import { toast } from "sonner";

interface Props {
  /** Prosjektkode brukes i filnavnet; faller tilbake på prosjekt-id. */
  filenameKey: string;
  extras: ExtraListRow[];
}

/**
 * «Eksporter CSV» ved siden av «Print liste» på statistkortet (VIB-2398).
 * Samme rader og kolonner som utskriften, bare maskinlesbart — derfor samme
 * synlighet som print-knappen, ingen egen rolle-gating: knappen gir ikke
 * tilgang til data brukeren ikke allerede ser i lista og på utskriften.
 * (Lønnseksporten under Rapporter er noe annet: på tvers av prosjekter,
 * filtrert til lønnsmottakere, og gated på admin + feature-flagg.)
 */
export function StatisterExportButton({ filenameKey, extras }: Props) {
  function handleExport() {
    if (extras.length === 0) {
      toast.error("Ingen statister å eksportere");
      return;
    }
    downloadCsv(`statister-${filenameKey}.csv`, extrasListToCsv(extras));
  }

  return (
    <Button
      size="sm"
      variant="outline"
      className="h-7 text-xs"
      onClick={handleExport}
    >
      <SrIcon name="download" className="w-3 h-3 mr-1" /> Eksporter CSV
    </Button>
  );
}

export default StatisterExportButton;
